export function getNameAbbreviation(name: string) {
  return (
    name
      .split(' ')
      .map((i) => i?.[0]?.toUpperCase())
      .filter((char) => /^[a-z0-9]+$/i.exec(char) !== null)
      .join('') ?? ''
  ).slice(0, 2);
}
